function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, Array, JSON, Object, String, propertyBuilderFilterInput, propertyBuilderSearchInput, requestAnimationFrame) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['pane-base'] = function({
      updateSizeOnPostpatch
    } = {
      updateSizeOnPostpatch: true
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const postpatch = updateSizeOnPostpatch ? $helpers.updateRenderedSize : () => null;;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-base': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "hook": {
              insert: $helpers.updateRenderedSizeOnNextFrame,
              postpatch,
            },
            "class": {
              'builder-pane-container': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(block && block());;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['pane-title'] = function(title, options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-title': true
          },
        }, (function() {
          var __jade_nodes = [];
          options = options || {};
          __jade_nodes = __jade_nodes.concat((options.upsell) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-upsell-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: 'lightning-bolt'
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'builder-pane-upsell-text': true
                },
              }, [__vjadeSafeCode(title)]));
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": {
                  href: '/pricing',
                  target: '_blank'
                },
                "class": {
                  'builder-pane-upsell-text': true,
                  'builder-pane-upgrade-link': true
                },
              }, [__vjadeSafeCode(options.upsellLinkText)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((title) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "attrs": {
                  title
                },
                "class": {
                  'builder-pane-title-label': true
                },
              }, [__vjadeSafeCode(title)]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(block && block());
          __jade_nodes = __jade_nodes.concat((options.backButton && $helpers.numPanes() > 1) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.clickedBackButton
              },
              "class": {
                'builder-pane-title-button': true,
                'builder-pane-back-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: 'caret-left'
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((options.closeButton) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.clickedCloseButton
              },
              "class": {
                'builder-pane-title-button': true,
                'builder-pane-close-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: 'x'
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['highlight-matches'] = function(matches) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = (matches);
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, substr, si) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": Object.assign({}, {
                    'builder-pane-matches-search': !(si % 2)
                  }, {
                    'builder-pane-substr': true
                  }),
                }, [__vjadeSafeCode(substr)]));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var si = $$objKey;
                if ($$obj.hasOwnProperty(si)) {
                  $$iterated = true;
                  var substr = $$obj[si];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": Object.assign({}, {
                        'builder-pane-matches-search': !(si % 2)
                      }, {
                        'builder-pane-substr': true
                      }),
                    }, [__vjadeSafeCode(substr)]));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['screen-option'] = function(label, options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        options = options || {};
        __jade_nodes = __jade_nodes.concat((!options.noIcon) ? ((function() {
          var __jade_nodes = [];
          const icon = options.icon;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'builder-pane-option-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon,
                empty: !icon
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-option-label': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((options.matches) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['highlight-matches'].call(this, options.matches));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-label': true
              },
            }, [__vjadeSafeCode(label)]));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat((options.description) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-description': true
              },
            }, [__vjadeSafeCode(options.description)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['small-caret-icon'] = function(options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        options = options || {};
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-caret-icon': true,
            'builder-pane-small-caret': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": {
              icon: `caret-${options.direction || 'right'}`
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['pane-loader'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-loading': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['filter-dropdown'] = function({
      name = ``,
      title = ``,
      icon = null
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            [`filter-${name}-dropdown`]: true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("button", {
            "on": {
              click: () => $helpers.toggleMenu(name)
            },
            "class": {
              'filter-menu-button': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("span", {
              "class": {
                'button-flex-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon,
                  empty: !icon
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'filter-prop-name': true
                },
              }, [__vjadeSafeCode($helpers.truncateMiddle(title, 30))]));
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: `caret-down`
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'filter-menu': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
              "attrs": {
                open: $helpers.isMenuOpen(name)
              },
              "on": {
                change: ev => $helpers.menuChange(ev, name)
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(block && block());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['filter-operator-dropdown'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'filter-operator-dropdown': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": {
              options: JSON.stringify(FILTER_OPERATORS[clauseType]),
              'selected-option': clause.operator,
              'label-transform': `uppercase`,
            },
            "on": {
              change: $helpers.selectFilterOperator,
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['filter-string-input'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'filter-string-input-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("input", {
            "props": {
              type: `text`,
              value: clause.value,
              placeholder: ``,
            },
            "on": {
              input: ev => $helpers.updateFilterValue(ev.target.value),
            },
            "key": `string:${clause.operator}`,
            "hook": {
              insert: $helpers.handleFilterInputInsert
            },
            "class": {
              'filter-string-input': true
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['filter-number-input'] = function({
      value = ``,
      onInput = null,
      options = {}
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'filter-number-input-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("input", {
            "attrs": {
              type: `number`,
            },
            "props": {
              value,
            },
            "on": {
              input: onInput,
            },
            "hook": options.autofocus ? {
              insert: vnode => requestAnimationFrame(() => vnode.elm.focus())
            } : {},
            "key": options.key,
            "class": {
              'filter-numdate-input': true
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const clause = $helpers.getStagedFilterClause();
    const clauseType = clause.type;
    const {
      TYPE,
      FILTER_DROPDOWNS,
      FILTER_OPERATORS,
      STRING_OPERATOR,
      NUMBER_OPERATOR,
      DATETIME_OPERATOR
    } = $helpers;
    return {
      value: (h("div", {
        "class": {
          'builder-pane': true,
          'filter-property': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(jade_mixins['pane-base'].call({
          block: function() {
            return (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['pane-title'].call({
                block: function() {
                  return (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-dropdown'].call({
                      block: function() {
                        return (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("ul", {
                            "class": {
                              'filter-types': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((function() {
                              var $$obj = ($helpers.FILTER_TYPES);
                              var $$eachNodes;
                              var $$iterated = false;
                              if (Array.isArray($$obj)) {
                                $$eachNodes = $$obj.reduce(function($$eachNodes, filterType, $index) {
                                  $$iterated = true;
                                  return $$eachNodes.concat((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("li", {
                                      "on": {
                                        click: () => $helpers.selectFilterType(filterType.name)
                                      },
                                      "class": Object.assign({}, {
                                        'filter-menu-item-selected': filterType.name === clauseType
                                      }, {
                                        'filter-menu-item': true
                                      }),
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                        "attrs": {
                                          icon: filterType.icon
                                        },
                                      }));
                                      __jade_nodes = __jade_nodes.concat(filterType.name);;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this));
                                }, []);
                              } else {
                                $$eachNodes = [];
                                for (var $$objKey in $$obj) {
                                  (function() {
                                    var $index = $$objKey;
                                    if ($$obj.hasOwnProperty($index)) {
                                      $$iterated = true;
                                      var filterType = $$obj[$index];
                                      $$eachNodes = $$eachNodes.concat((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("li", {
                                          "on": {
                                            click: () => $helpers.selectFilterType(filterType.name)
                                          },
                                          "class": Object.assign({}, {
                                            'filter-menu-item-selected': filterType.name === clauseType
                                          }, {
                                            'filter-menu-item': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                            "attrs": {
                                              icon: filterType.icon
                                            },
                                          }));
                                          __jade_nodes = __jade_nodes.concat(filterType.name);;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this));
                                    }
                                  })();
                                }
                              }

                              return $$eachNodes;
                            })());;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this);
                      }
                    }, {
                      name: FILTER_DROPDOWNS.Type,
                      title: $helpers.renameProperty(clause.property, {
                        dataGroupId: clause.dataGroupId
                      }),
                      icon: $helpers.getIconForPropertyType(clauseType)
                    }));;
                    return __jade_nodes
                  }).call(this);
                }
              }, ``, {
                backButton: true
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "hook": {
                  postpatch: $helpers.updateRenderedSize
                },
                "class": Object.assign({}, {
                  [`filter-type-${clauseType}`]: true
                }, {
                  'filter-chooser': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((((clauseType) == (TYPE.String))) ?
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-operator-dropdown'].call(this));
                    __jade_nodes = __jade_nodes.concat((((clause.operator) == (STRING_OPERATOR.Contains)) || ((clause.operator) == (STRING_OPERATOR.DoesNotContain))) ?
                      ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['filter-string-input'].call(this));
                        __jade_nodes = __jade_nodes.concat((clause.loadingValues) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['pane-loader'].call(this));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                            "attrs": {
                              progressive: true,
                              'search-filter': $helpers.renamePropertyValue(clause.value || ``),
                              sections: JSON.stringify($helpers.getPropertyValueSections()),
                            },
                            "on": {
                              clickItem: $helpers.handleSelectContainsItem,
                              draw: $helpers.updateRenderedSize,
                            },
                            "props": {
                              keydownProxyEl: propertyBuilderFilterInput
                            },
                            "class": {
                              'cohorts-property-value-list': true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this)) :
                      (((clause.operator) == (STRING_OPERATOR.Equals)) || ((clause.operator) == (STRING_OPERATOR.DoesNotEqual))) ?
                      ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((clause.loadingValues) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['pane-loader'].call(this));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'filter-string-input-wrapper': true,
                              'filter-string-search': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
                              "attrs": {
                                icon: `search`,
                                placeholder: `Search`,
                                value: clause.filterSearch,
                              },
                              "key": `string:${clause.operator}`,
                              "hook": {
                                insert: $helpers.handleSearchInputInsert
                              },
                              "on": {
                                input: ev => $helpers.updateFilterSearch(ev.target.value),
                              },
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("mp-checkbox-list", {
                            "attrs": {
                              progressive: true,
                              'show-csv-matches': true,
                              'search-filter': clause.filterSearch || ``,
                              items: JSON.stringify($helpers.getPropertyValues()),
                            },
                            "on": {
                              selectAll: $helpers.handleSelectAllPropertyValues,
                              unselectAll: $helpers.handleUnselectAllPropertyValues,
                              clickItem: $helpers.handleTogglePropertyValue,
                              draw: $helpers.updateRenderedSize,
                              selectAllMatching: $helpers.selectAllMatching,
                            },
                            "props": {
                              keydownProxyEl: propertyBuilderSearchInput
                            },
                            "class": {
                              'cohorts-property-value-checkbox-list': true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this)) :
                      undefined);;
                    return __jade_nodes
                  }).call(this)) :
                  (((clauseType) == (TYPE.Number))) ?
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-operator-dropdown'].call(this));
                    __jade_nodes = __jade_nodes.concat((((clause.operator) == (NUMBER_OPERATOR.Between))) ?
                      ((function() {
                        var __jade_nodes = [];
                        const [start, end] = Array.isArray(clause.value) ? clause.value : [null, null];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'filter-numdate': true,
                            'filter-numdate-between': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['filter-number-input'].call(this, {
                            value: start,
                            onInput: ev => $helpers.updateFilterValue([$helpers.parseNumber(ev.target.value), end]),
                            options: {
                              autofocus: true,
                              key: `num-start`
                            }
                          }));
                          __jade_nodes = __jade_nodes.concat(h("span", {
                            "class": {
                              'filter-conjunction': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("and");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(jade_mixins['filter-number-input'].call(this, {
                            value: end,
                            onInput: ev => $helpers.updateFilterValue([start, $helpers.parseNumber(ev.target.value)]),
                            options: {
                              autofocus: false,
                              key: `num-end`
                            }
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) :
                      ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'filter-numdate': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['filter-number-input'].call(this, {
                            value: clause.value,
                            onInput: ev => $helpers.updateFilterValue($helpers.parseNumber(ev.target.value)),
                            options: {
                              autofocus: true,
                              key: `num-val: ${clause.operator}`
                            }
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)));;
                    return __jade_nodes
                  }).call(this)) :
                  (((clauseType) == (TYPE.Datetime))) ?
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-operator-dropdown'].call(this));
                    __jade_nodes = __jade_nodes.concat(h("cohorts-date-range-picker", {
                      "attrs": $helpers.getDateRangePickerAttrs(),
                      "on": {
                        change: $helpers.updateDateFilterValue,
                        draw: $helpers.updateRenderedSize,
                      },
                      "hook": {
                        insert: $helpers.updateRenderedSize,
                      },
                    }));;
                    return __jade_nodes
                  }).call(this)) :
                  (((clauseType) == (TYPE.Boolean)) || ((clauseType) == (TYPE.List))) ?
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": Object.assign({}, {
                        [`filter-radio-list-${clauseType}`]: true
                      }, {
                        'filter-radio-list': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var $$obj = (FILTER_OPERATORS[clauseType]);
                        var $$eachNodes;
                        var $$iterated = false;
                        if (Array.isArray($$obj)) {
                          $$eachNodes = $$obj.reduce(function($$eachNodes, filterOperator, $index) {
                            $$iterated = true;
                            return $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'radio-button-container': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-radio-button", {
                                  "attrs": {
                                    selected: filterOperator === clause.operator
                                  },
                                  "on": {
                                    click: () => $helpers.handleFilterOperatorRadioButtonClick(filterOperator)
                                  },
                                }, [__vjadeSafeCode(filterOperator)]));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }, []);
                        } else {
                          $$eachNodes = [];
                          for (var $$objKey in $$obj) {
                            (function() {
                              var $index = $$objKey;
                              if ($$obj.hasOwnProperty($index)) {
                                $$iterated = true;
                                var filterOperator = $$obj[$index];
                                $$eachNodes = $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'radio-button-container': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("mp-radio-button", {
                                      "attrs": {
                                        selected: filterOperator === clause.operator
                                      },
                                      "on": {
                                        click: () => $helpers.handleFilterOperatorRadioButtonClick(filterOperator)
                                      },
                                    }, [__vjadeSafeCode(filterOperator)]));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this));
                              }
                            })();
                          }
                        }

                        return $$eachNodes;
                      })());;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat((clauseType === TYPE.List) ? ((function() {
                      var __jade_nodes = [];
                      const isMessagesSentProperty = $helpers.isMessagesSentProperty();
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": Object.assign({}, {
                          'filter-list-dropdown': isMessagesSentProperty
                        }, {
                          'filter-list-value-section': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((isMessagesSentProperty) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-select", {
                            "attrs": {
                              'menu-height': 180,
                              'searchable': true,
                              'selected-option': clause.value ? $helpers.renamePropertyValue(clause.value) : `Select an option`,
                              'sections': JSON.stringify($helpers.getMessagesSentSections()),
                            },
                            "on": {
                              'change': ev => $helpers.updateFilterValue(ev.detail.item.value),
                            },
                          }));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['filter-string-input'].call(this));;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this)) :
                  undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                "attrs": {
                  'disabled': $helpers.disableSaveButton()
                },
                "on": {
                  click: $helpers.savePropertyFilter
                },
                "class": {
                  'mp-button-bar-primary': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Add filter");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this);
          }
        }, {
          updateSizeOnPostpatch: false
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "propertyBuilderFilterInput" in locals ? locals.propertyBuilderFilterInput : typeof propertyBuilderFilterInput !== "undefined" ? propertyBuilderFilterInput : undefined, "propertyBuilderSearchInput" in locals ? locals.propertyBuilderSearchInput : typeof propertyBuilderSearchInput !== "undefined" ? propertyBuilderSearchInput : undefined, "requestAnimationFrame" in locals ? locals.requestAnimationFrame : typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;